import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const EXPANDED_VIEW_CTA_SCHEMA = Object.freeze({
  TITLE: '',
  DEEPLINK: '',
});
export const RECORD = generateSchema(EXPANDED_VIEW_CTA_SCHEMA);
export const KEYS: any = generateKeys(EXPANDED_VIEW_CTA_SCHEMA);

export class ExpandedViewCta extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get deeplink(): string {
    return this.get(KEYS.DEEPLINK);
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }
}
